import { useContext } from 'react';
import { ThemeToggleContext } from './use-theme-toggler.context';

export const useThemeToggler = () => {
  return useContext(ThemeToggleContext);
};
